import { useState, useRef, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import RichContent from "./RichContent";

export default function RichTextReadMore({ htmlContent, maxLines = 4, postId, src, state, isPublicProfileURL }) {
    const [isExpanded, setIsExpanded] = useState(false);
    const [showReadMore, setShowReadMore] = useState(false);
    const contentRef = useRef(null);

    const checkOverflow = () => {
        if (contentRef.current) {
            // Use a small timeout to ensure the shadow DOM layout has been calculated
            setTimeout(() => {
                if (contentRef.current) {
                    const shadowRoot = contentRef.current.shadowRoot;
                    const internalBody = shadowRoot?.querySelector(".rich-content-body");
                    if (internalBody) {
                        const { scrollHeight } = internalBody;
                        const { clientHeight } = contentRef.current;
                        setShowReadMore(scrollHeight > clientHeight);
                    } else {
                        // Fallback to host measurement if shadow not ready
                        const { scrollHeight, clientHeight } = contentRef.current;
                        setShowReadMore(scrollHeight > clientHeight);
                    }
                }
            }, 100);
        }
    };

    useEffect(() => {
        checkOverflow();
        window.addEventListener("resize", checkOverflow);
        
        // Since images are inside Shadow DOM, we can't easily attach 'load' listeners from here.
        // However, the ResizeObserver or a simple delayed check can help.
        const timer = setTimeout(checkOverflow, 1000); // Fallback check after 1s
        
        return () => {
            window.removeEventListener("resize", checkOverflow);
            clearTimeout(timer);
        };
    }, [htmlContent, maxLines]);

    return (
        <div>
            <RichContent
                ref={contentRef}
                content={htmlContent}
                maxLines={!isExpanded ? maxLines : 0}
                style={isExpanded ? { overflow: "visible" } : {}}
            />
            {!isExpanded && showReadMore && (
                <>
                    {isPublicProfileURL ? <Link
                        to={{ pathname: isPublicProfileURL, src: src }}
                        className="justify-end flex mt-4 blueColor cursor-pointer"
                    >
                        Read More...
                    </Link> : <>
                        {state && src ? (
                            <Link
                                to={{
                                    pathname: "/post/" + postId,
                                    src: src,
                                    state: { state },
                                }}
                                className="justify-end flex mt-4 blueColor cursor-pointer"
                            >
                                Read More...
                            </Link>
                        ) : (
                            <Link
                                to={"/post/" + postId}
                                className="justify-end flex mt-4 blueColor cursor-pointer"
                            >
                                Read More...
                            </Link>
                        )}
                    </>
                    }
                </>
            )}
        </div>
    );
}
